import { RequireAccess } from '@/components'
import { type ReactNode, useMemo } from 'react'
import { createDesignGalleryStore, DesignGalleryStoreContext } from './store'
import { DesignGalleryPicker } from './ui'

/**
 * Mount this once in the app frame, wrapping the app's content.
 * Provides the design gallery store to all descendants and renders
 * the picker dialog when opened via `useDesignGallery().open()`.
 */
export function DesignGalleryManager({ children }: { children?: ReactNode }) {
	const store = useMemo(() => createDesignGalleryStore(), [])

	return (
		<DesignGalleryStoreContext.Provider value={store}>
			<RequireAccess role="jobillan">
				<DesignGalleryPicker />
			</RequireAccess>
			{children}
		</DesignGalleryStoreContext.Provider>
	)
}
